import { useInView } from 'react-intersection-observer';
import { useRouter } from 'src/hooks/useRouter';
import { updateEvPage } from 'src/utils/router';

const PageSeparator = ({ pageNumber }) => {
  const router = useRouter();
  const { ref } = useInView({
    rootMargin: '-250px -100px',
    onChange: (inView, entry) => {
      if (inView) {
        const pageNumber = entry?.target.dataset.pageNumber;
        if (pageNumber) {
          updateEvPage(router, pageNumber);
        }
      }
    },
  });

  return <div className="page-separator" ref={ref} data-page-number={pageNumber} />;
};

export default PageSeparator;
